"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateOverrideLogicalOperators = exports.RateOverrideLogicalOperator = void 0;
var RateOverrideLogicalOperator;
(function (RateOverrideLogicalOperator) {
    RateOverrideLogicalOperator["And"] = "and";
    RateOverrideLogicalOperator["Or"] = "or";
})(RateOverrideLogicalOperator = exports.RateOverrideLogicalOperator || (exports.RateOverrideLogicalOperator = {}));
exports.RateOverrideLogicalOperators = Object.values(RateOverrideLogicalOperator);
//# sourceMappingURL=rate-override-logical-operator.js.map